module.exports = {
  PAGE: 'PAGE',
  BLOG: 'BLOG'
};
